import { useQuery } from "@tanstack/react-query";
import { fetcher } from "@/shared/api";
import { countryKeys } from "./queryKeys";
import { normalizeCountries } from "../model/currency";
import type { SupportedCountry } from "../model/types";

/** Active supported countries for the onboarding region picker.
 *  Namespace interceptor maps `/countries` → `/api/v2/merchant/countries`. */
export function useCountryList() {
  return useQuery<SupportedCountry[]>({
    queryKey: countryKeys.lists(),
    queryFn: async () => normalizeCountries(await fetcher("/countries")),
    // Country list is near-static — cache aggressively.
    staleTime: 60 * 60 * 1000,
  });
}
